import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ChakraBaseProvider } from "@chakra-ui/react";
import theme from "./theme";
import { QueryClient, QueryClientProvider } from "react-query";
import { UserContextProvider } from "context/UserContext";
import { ShipmentFormProvider } from "context/DHLShipmentFormContext";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ChakraBaseProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <UserContextProvider>
          <ShipmentFormProvider>
            <App />
          </ShipmentFormProvider>
        </UserContextProvider>
      </QueryClientProvider>
    </ChakraBaseProvider>
  </React.StrictMode>
);
